import { defineNuxtPlugin } from '#app'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  const store = useStore()

  store.commit('setMode', getModeFromUrl(window.location.href))

  router.afterEach(() => {
    store.commit('setMode', getModeFromUrl(window.location.href))
  })
})
